module.exports = __webpack_public_path__ + "static/media/moving_banner_mobile.835a67c3.MOV";